import { render, staticRenderFns } from "./SuratSehatBody.vue?vue&type=template&id=092fcf8c&"
import script from "./SuratSehatBody.vue?vue&type=script&lang=js&"
export * from "./SuratSehatBody.vue?vue&type=script&lang=js&"
import style0 from "./SuratSehatBody.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports